import { render, staticRenderFns } from "./ViewOrderType.vue?vue&type=template&id=4ef85174&scoped=true&"
import script from "./ViewOrderType.vue?vue&type=script&lang=js&"
export * from "./ViewOrderType.vue?vue&type=script&lang=js&"
import style0 from "./ViewOrderType.vue?vue&type=style&index=0&id=4ef85174&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef85174",
  null
  
)

export default component.exports